import React from "react";
import cn from "classnames";
import "./Heading.scss";

const variantsMapping: { [key: string]: string } = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  heading: "h1",
  headinglarge: "h1",
  small: "h6",
  text: "div",
};

interface ITypography {
  variant?: string;
  color?: string;
  weight?: string;
  margin?: number;
  size?: string;
  children?: JSX.Element | string;
  lineclamp?: number;
  textalign?: string;
}

export const Heading = (props: ITypography) => {
  const { variant, color, weight, size, lineclamp, children, textalign } = props;
  const Component: any = variant ? variantsMapping[variant] : "div";
  return (
    <Component
      className={cn({
        [`headingvariant_${variant}`]: variant,
        [`headingcolor-${color}`]: color,
        [`headingweight-${weight}`]: weight,
        [`headingsize-${size}`]: size,
        [`lineclamp-${lineclamp}`]: lineclamp,
        [`textalign-${textalign}`]: textalign,

      })}
      // {...props}
      dangerouslySetInnerHTML={{
        __html: children,
      }}
    />
  );
};